<div class="w-full h-full">
  <p-dialog
    [draggable]="false"
    [(visible)]="needToCalculate"
    [closable]="false"
    appendTo="self"
  >
    <i class="pi pi-exclamation-circle pr-1"></i> <label>Please calculate PERINIX to view results.</label>
    <br />
    <br />
  </p-dialog>

  <app-tool-loader [isLoading]="isLoading()" positionUnset="true">

    <p-toolbar>
      <ng-template #start>
        <div class="flex gap-2">
          <p-selectButton [options]="resultsDisplay" [(ngModel)]="selectedResultsDisplay"
            (onChange)="onSelectedResultsDisplayUpdated($event)" [allowEmpty]="false"></p-selectButton>

          @if (selectedResultsDisplay === 'plot') {
            <p-selectButton [options]="apbAfe" [(ngModel)]="apbAfeSelected"
              (onChange)="onApbAfeSelected($event)"
              [allowEmpty]="false"></p-selectButton>
          }
        </div>
      </ng-template>
    </p-toolbar>

    <app-ng-table-results 
      [hidden]="selectedResultsDisplay !== 'grid'"
      tableName="Annular Pressure Build-Up Results" 
      [tableData]="apbResults"
      [columnDefinitions]="cols"
      [autoHeight]="true"
    />

    <app-xy-line-plot [hidden]="selectedResultsDisplay !== 'plot'" [plotData]="plot.data"
      [xAxisTitle]="''" [yAxisTitle]="yAxisTitle" [plotName]="plotName" [downloadPlotName]="downloadPlotName"
      [reverseAutoRange]="true" [legendBelowPlot]="true" [plotTitle]="'APB Results'" [xyLinePlotStore]="apbResultsStore">
    </app-xy-line-plot>

</app-tool-loader>
